import { fetchApi } from './fetchApi'

export const fetchAlbumsApi = () => fetchApi('/albums')
